/* Viventi · visor de fotos de la ficha (doc 54). PhotoSwipe 5 cargado solo al tocar la galería. */
(function () {
  if (window.__vvVisor) return; window.__vvVisor = true;
  var nodo = document.getElementById('vv-visor-data');
  if (!nodo) return;
  var data; try { data = JSON.parse(nodo.textContent); } catch (e) { return; }
  data = (data || []).filter(function (d) { return d && (d.src || d.type === 'video'); });
  if (!data.length) return;

  var BASE = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/';
  var mod = null, cssOk = false;
  function cargar() {
    if (!cssOk) {
      cssOk = true;
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = BASE + 'photoswipe.css'; document.head.appendChild(l);
      var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s);
    }
    /* UMD por <script>: el minificador de Shopify rompe import() dinamico */
    return mod || (mod = new Promise(function (ok, no) {
      if (window.PhotoSwipe) return ok(window.PhotoSwipe);
      var sc = document.createElement('script'); sc.src = BASE + 'umd/photoswipe.umd.min.js'; sc.async = true;
      sc.onload = function () { window.PhotoSwipe ? ok(window.PhotoSwipe) : no(new Error('sin PhotoSwipe')); };
      sc.onerror = function (e) { mod = null; no(e); };
      document.head.appendChild(sc);
    }));
  }

  var CSS = [
    '.pswp{--pswp-bg:#FAF6EF;--pswp-placeholder-bg:#EDE6DA;--pswp-icon-color:#0E5A52;--pswp-icon-color-secondary:#FAF6EF;--pswp-icon-stroke-color:#FAF6EF;--pswp-icon-stroke-width:2px;--pswp-error-text-color:#1E2A28}',
    '.pswp__counter{color:#0E5A52;opacity:1;font:600 15px/1 Poppins,system-ui,sans-serif;text-shadow:none;margin-top:20px}',
    '.pswp__button{opacity:1}',
    '.pswp div:empty{display:block}',
    '.pswp__vv-thumbs{position:absolute;left:0;right:0;bottom:calc(10px + env(safe-area-inset-bottom));display:flex;gap:8px;overflow-x:auto;padding:4px 12px;scrollbar-width:none;-webkit-overflow-scrolling:touch}',
    '.pswp__vv-thumbs::-webkit-scrollbar{display:none}',
    '@media (min-width:750px){.pswp__vv-thumbs{justify-content:center}}',
    '.pswp__vv-thumbs button{position:relative;flex:none;width:56px;height:56px;padding:0;border:2px solid transparent;border-radius:10px;background:#fff;overflow:hidden;opacity:.55;cursor:pointer;transition:opacity .2s,border-color .2s}',
    '.pswp__vv-thumbs button.is-on{border-color:#C46A2E;opacity:1}',
    '.pswp__vv-thumbs img{width:100%;height:100%;object-fit:cover;display:block}',
    '.pswp__vv-thumbs span{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;font-size:18px;background:rgba(14,90,82,.35)}',
    '.pswp__vv-caption{position:absolute;left:50%;transform:translateX(-50%);bottom:calc(84px + env(safe-area-inset-bottom));max-width:90%;background:rgba(14,90,82,.92);color:#fff;font:500 12px/1.3 Poppins,system-ui,sans-serif;padding:5px 12px;border-radius:999px;white-space:nowrap;pointer-events:none}',
    '.pswp .pswp__vv-caption:empty{display:none}',
    '.pswp__vv-hint{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);background:rgba(30,42,40,.86);color:#fff;font:500 14px/1.35 Poppins,system-ui,sans-serif;padding:12px 18px;border-radius:14px;text-align:center;pointer-events:none;transition:opacity .5s}',
    '.vv-pv{display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:64px 12px 104px;box-sizing:border-box}',
    '.vv-pv video{max-width:100%;max-height:100%;border-radius:10px;background:#000}'
  ].join('');

  function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fuente() {
    return data.map(function (d) {
      if (d.type === 'video') {
        return { html: '<div class="vv-pv"><video src="' + esc(d.src) + '" poster="' + esc(d.poster) + '" controls playsinline preload="metadata"></video></div>', alt: d.alt };
      }
      return { src: d.src, msrc: d.msrc, width: d.w, height: d.h, alt: d.alt };
    });
  }

  function sincronizar(i) {
    var d = data[i]; if (!d) return;
    var li = document.querySelector('.product__media-item[data-media-id$="-' + d.id + '"]');
    var lista = li && li.parentElement;
    if (lista && lista.scrollWidth > lista.clientWidth) lista.scrollTo({ left: li.offsetLeft - lista.offsetLeft, behavior: 'instant' });
  }

  function abrir(indice) {
    cargar().then(function (PhotoSwipe) {
      var p = new PhotoSwipe({
        dataSource: fuente(), index: indice, bgOpacity: 1, showHideAnimationType: 'fade',
        padding: { top: 64, bottom: 104, left: 0, right: 0 }, wheelToZoom: true,
        tapAction: 'toggle-controls', doubleTapAction: 'zoom', imageClickAction: 'zoom',
        closeTitle: 'Cerrar', zoomTitle: 'Acercar', arrowPrevTitle: 'Anterior', arrowNextTitle: 'Siguiente',
        errorMsg: 'No se pudo cargar la imagen', indexIndicatorSep: ' / '
      });
      p.on('uiRegister', function () {
        p.ui.registerElement({ name: 'vv-caption', order: 9, isButton: false, appendTo: 'root', onInit: function (el) {
          p.on('change', function () { var a = (p.currSlide && p.currSlide.data.alt) || ''; el.textContent = a.indexOf('Imagen ilustrativa') === 0 ? 'Imagen ilustrativa · el producto es el real' : ''; });
        } });
        p.ui.registerElement({ name: 'vv-thumbs', order: 10, isButton: false, appendTo: 'root', onInit: function (el) {
          data.forEach(function (d, i) {
            var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Ver imagen ' + (i + 1) + ' de ' + data.length);
            b.innerHTML = '<img src="' + esc(d.thumb) + '" alt="" loading="lazy">' + (d.type === 'video' ? '<span aria-hidden="true">▶</span>' : '');
            b.addEventListener('click', function (ev) { ev.stopPropagation(); p.goTo(i); });
            el.appendChild(b);
          });
          p.on('change', function () {
            for (var k = 0; k < el.children.length; k++) el.children[k].classList.toggle('is-on', k === p.currIndex);
            var on = el.children[p.currIndex];
            if (on) el.scrollTo({ left: on.offsetLeft - el.clientWidth / 2 + on.clientWidth / 2, behavior: 'smooth' });
          });
        } });
        var visto = false; try { visto = sessionStorage.getItem('vvVisorHint') === '1'; sessionStorage.setItem('vvVisorHint', '1'); } catch (e) {}
        if (!visto && window.matchMedia('(pointer: coarse)').matches) {
          p.ui.registerElement({ name: 'vv-hint', order: 11, isButton: false, appendTo: 'root', onInit: function (el) {
            el.textContent = 'Toca dos veces o pellizca para acercar · desliza para ver más';
            setTimeout(function () { el.style.opacity = '0'; }, 2600);
            setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 3200);
          } });
        }
      });
      p.on('change', function () { document.querySelectorAll('.pswp video').forEach(function (v) { if (!p.currSlide || !p.currSlide.container.contains(v)) v.pause(); }); });
      p.on('close', function () { document.querySelectorAll('.pswp video').forEach(function (v) { v.pause(); }); sincronizar(p.currIndex); });
      p.init();
    }).catch(function () {
      /* si el visor no carga, se abre el de Dawn como antes */
      var o = document.querySelector('.product__media-item modal-opener'); if (o && o.querySelector('button')) { window.__vvVisorOff = true; o.querySelector('button').click(); }
    });
  }

  document.addEventListener('click', function (e) {
    if (window.__vvVisorOff) return;
    var o = e.target.closest && e.target.closest('.product__media-item modal-opener, .product__media-item .product__media-toggle');
    if (!o) return;
    var li = o.closest('[data-media-id]'); if (!li) return;
    var id = String(li.getAttribute('data-media-id')).split('-').pop();
    var i = -1; for (var k = 0; k < data.length; k++) if (String(data[k].id) === id) { i = k; break; }
    if (i < 0) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    abrir(i);
  }, true);

  var lista = document.querySelector('.product__media-list');
  if (lista) lista.addEventListener('pointerdown', function () { cargar(); }, { once: true, passive: true });
})();